import React from 'react';

// Prominent "work in progress" banner shown at the top of the in-development
// custom-analytics report tabs (Reimbursement Receipts, Utility Allocation Export)
// while their figures are still being validated.
export const WipBanner = () => /*#__PURE__*/React.createElement("div", {
  role: "alert",
  style: {
    background: '#fdecea',
    border: '2px solid #c43131',
    borderRadius: 8,
    padding: '14px 18px',
    marginBottom: 16,
    color: '#c43131',
    fontWeight: 800,
    fontSize: 18,
    lineHeight: 1.4,
    textAlign: 'center'
  }
}, "Work in progress \u2014 not ready for use yet. Reach out to mitch.zink@livable.com on Slack with any questions or concerns.");